import Vue from 'vue';
import getTransformedDeclension from '~/assets/services/helpers/getTransformedDeclension';

Vue.filter('transformQuantity', (currentQty, currentNumeralName) => getTransformedDeclension(currentQty, currentNumeralName, true));
Vue.filter('transformQuantityWithoutQty', (currentQty, currentNumeralName) => getTransformedDeclension(currentQty, currentNumeralName, false));
